var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDailyCircleChecker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0.75C8.8995 0.75 11.25 3.10051 11.25 6C11.25 8.8995 8.8995 11.25 6 11.25C3.10051 11.25 0.75 8.8995 0.75 6C0.75 3.10051 3.10051 0.75 6 0.75ZM8.35984 4.44653L5.32293 7.48344L3.64017 5.80068C3.49372 5.65423 3.25628 5.65423 3.10983 5.80068C2.96339 5.94713 2.96339 6.18456 3.10983 6.33101L5.05776 8.27894C5.20421 8.42538 5.44164 8.42538 5.58809 8.27894L8.89017 4.97686C9.03661 4.83042 9.03661 4.59298 8.89017 4.44653C8.74372 4.30009 8.50628 4.30009 8.35984 4.44653Z",
    fill: "url(#paint0_linear_1035_79)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1035_79",
    x1: 0.75,
    y1: 5.99998,
    x2: 11.25,
    y2: 5.99998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13A165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35C2BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyCircleChecker);
export default __webpack_public_path__ + "static/media/daily_circle_checker.3c95f32da8362290c4ff1ceec4f1696d.svg";
export { ForwardRef as ReactComponent };